import React from 'react';
import { motion } from 'framer-motion';

const ServiceSection = ({ 
  reference, 
  badge, 
  title, 
  description, 
  titleLines = []
}) => {
  return (
    <section 
      ref={reference} 
      className="py-8 md:py-16 lg:py-24 min-h-0 md:min-h-screen flex items-center"
    >
      <div className="md:max-w-md">
        <motion.span 
          className="inline-block text-indigo-600 font-medium mb-2"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          {badge}
        </motion.span>
        
        <motion.h2 
          className="text-2xl md:text-3xl lg:text-5xl font-medium mb-8 text-[#0a2540] leading-tight max-w-md"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {titleLines.map((line, index) => (
            <span key={index} className="block mb-2">{line}</span>
          ))}
        </motion.h2>
        
        <motion.p 
          className="text-gray-600"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          {description}
        </motion.p>
      </div>
    </section>
  );
};

export default ServiceSection;
